"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var http_service_1 = require("./http.service");
var find_http_error_1 = require("../error/find-http-error");
var EquipmentService = /** @class */ (function () {
    function EquipmentService(_httpService) {
        this._httpService = _httpService;
        this.FIND_BY_IMEI = EquipmentService.EQUIPMENT_END_POINT + "/findByImeiContains";
        this.FIND_BY_SERIAL = EquipmentService.EQUIPMENT_END_POINT + "/findBySerialContains";
        this.FIND_BY_SERIAL_AND_STATUS = EquipmentService.EQUIPMENT_END_POINT + "/findByStatusAndSerialContains";
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    EquipmentService.prototype.findByImei = function (imei) {
        this.findEquipment(this._httpService.get(this.FIND_BY_IMEI + "/" + imei, Array, find_http_error_1.FindHttpError));
    };
    EquipmentService.prototype.findBySerial = function (serial) {
        this.findEquipment(this._httpService.get(this.FIND_BY_SERIAL + "/" + serial, Array, find_http_error_1.FindHttpError));
    };
    EquipmentService.prototype.findBySerialAndStatus = function (serial, status) {
        var finalUrl = this.FIND_BY_SERIAL_AND_STATUS + "/" + serial + "?status=" + status;
        this.findEquipment(this._httpService.get(finalUrl, Array, find_http_error_1.FindHttpError));
    };
    EquipmentService.prototype.findEquipment = function (observable) {
        var _this = this;
        observable
            .subscribe(function (equipment) { return _this.findSubject.next(equipment); }, function (error) { return _this.errorSubject.next(error); });
    };
    EquipmentService.ctorParameters = function () { return [{ type: http_service_1.HttpService }]; };
    EquipmentService.EQUIPMENT_END_POINT = '/equipment';
    return EquipmentService;
}());
exports.EquipmentService = EquipmentService;
//# sourceMappingURL=equipment.service.js.map


// WEBPACK FOOTER //
// equipment.service.js